import clsx from 'clsx';
import { KTIcon, toAbsoluteUrl } from '../../../helpers';
import { HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher } from '../../../partials';
import { useLayout } from '../../core'
import { useAppSelector, useAppDispatch } from '../../../../app/hooks';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { SidebarMenuMain } from '../sidebar/sidebar-menu/SidebarMenuMain';
import { useEffect, useState } from 'react';
import { Sidebar } from '../sidebar';
import { checkedshowAdminPagesState, getAccountFeatureAsync, getPagePermissionsAsync } from '../../../../common/GlobalSlice';
import { ShowToast } from '../../../../common/Toastr';
import {
  stopAccountEmployeeTimeEntryTimerAsync, updateIsReload, updateTimerFromNavbarState, updateTimerTimesheet,
  deleteAccountEmployeeTimeEntryTimerAsync
} from '../../../../features/timesheet/timesheetSlice';
import { getTimeFromDecimal, timeConverIntoSeconds } from '../../../../common/timesheetFunction';
import moment from 'moment';
import { Profile } from '../../../../features/profile/Profile';
import { Tooltip } from 'react-tooltip';
import { callServices, getValueFromResource } from '../../../../common/timeLiveFunction';
import Loader from '../../../../common/Loader';
import { useTranslation } from 'react-i18next';
import { debounce } from '@mui/material';
import "../../../../common/css/timeLive.css";
import TimerInforWedget from '../../../../features/timesheet/TimerInfoWidget';
import fetchAPI from '../../../../common/fetchAPI';
import TimeinTimeout from '../../../../features/attendance/TimeinTimeout';
import NotificationWidget from '../../../../features/timesheet/NotificationWidget';
import { useRuntimeConfig } from '../../../../hooks/useRuntimeConfig';

const itemClass = 'ms-1 ms-lg-3';
const userAvatarClass = 'symbol-35px symbol-md-35px';
const btnClass = 'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px';
const btnIconClass = 'fs-1 text-gray-600';

const Navbar = () => {
  // const {config} = useLayout()
  const { timerObject, lastEntryTimerId, timeEntriesList, hoursRedux, minutesRedux, secondsRedux, autoTimer, isTimerCloseWithNoEntry } = useAppSelector((state) => state.timesheet);
  const { sessionAccountId, sessionAccountEmployeeId, profilePictureColor, shortName, showEmployeeProfilePicture, profileURL, accountFeatureList, notificationEvents } = useAppSelector((state) => state.globalState);
  const { IsTimeInOutAvailable } = useAppSelector((state) => state.profile);
  const { SelectedCurrentHostedPackage } = useAppSelector((state) => state.licenseActivation);
  const [systemSecurityCategoryPageId, setSystemSecurityCategoryPageId] = useState<number>(-1);
   const [addAttendance, setAddAttendance] = useState(false);
  const [isAdminMenuOpen, setIsAdminMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const { isUpdateData } = useAppSelector((state) => state.featureManagement);
  const isEnableAttandance = accountFeatureList.find((item) => item.Name === 'Attendance')?.Name;
  const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
  const IsFreeLicenseExpired = localStorage.getItem("IsFreeLicenseExpired");
  const isAttendenceBtn = localStorage.getItem('showAttendanceBtn');
  const expireFalg = (licenseExpireFlag === "true" || IsFreeLicenseExpired === "true");
  const showCalendar = accountFeatureList?.some((item: any) => item?.Id === '9289f75c-48be-4002-bef6-df8be6e014cb') ?? false;
  const today = new Date();
  const cutoffDate = new Date('2025-07-05');
  const config = useRuntimeConfig();

  const handleToggleAdminMenu = () => {
    localStorage.setItem('objAdmin', JSON.stringify(true));
    if (expireFalg) {
      navigate('/expiry')
    } else {
      dispatch(checkedshowAdminPagesState());
      navigate('/profile');
    }
    //setIsAdminMenuOpen(!isAdminMenuOpen);
  }

  useEffect(() => {
    const fetchPagePermissions = async () => {
      const res = await dispatch(getPagePermissionsAsync(15));
      if (res.payload.IsList) {
        setSystemSecurityCategoryPageId(15);
      }
    }
    fetchPagePermissions();
    getCustomPagePermissionsAsync(186)
  }, [dispatch]);
  useEffect(() => {
    dispatch(getAccountFeatureAsync()).then((res: any) => { })
  }, [isUpdateData]);


  const getCustomPagePermissionsAsync = async (arg: any) => {
    try {
      const response = await fetchAPI(
        `api/v2/PagePermission/GetCustomPagePermissions/?value=${arg}`, "GET", "", true);
      const json = await response.json();
      const record = json?.find?.((x: any) => x.Id === 186);
      setAddAttendance(!!record?.IsAdd); 
    } catch (error) {
      console.error("Permission fetch error:", error);
      setAddAttendance(false);
    }
  };


  const [time, setTime] = useState({ hours: hoursRedux, minutes: minutesRedux, seconds: secondsRedux });
  const [intervalId, setIntervalId] = useState<any | null>();

  useEffect(() => {
    isTimerCloseWithNoEntry === false ? setTime({ hours: hoursRedux, minutes: minutesRedux, seconds: secondsRedux }) :
      setTime({ hours: 0, minutes: 0, seconds: 0 });
  }, [hoursRedux, minutesRedux, secondsRedux, isTimerCloseWithNoEntry]);

  useEffect(() => {
    if (autoTimer) {
      const id = setInterval(() => {
        setTime((prevTime) => {
          const newSeconds = prevTime.seconds + 1;
          const newMinutes = prevTime.minutes + Math.floor(newSeconds / 60);
          const newHours = prevTime.hours + Math.floor(newMinutes / 60);
          dispatch(updateTimerTimesheet({
            timerArray: [{
              hours: newHours,
              minutes: newMinutes % 60,
              seconds: newSeconds % 60
            }]
          }));
          // debouncedUpdateTimer({ hours: newHours, minutes: newMinutes % 60, seconds: newSeconds % 60 });
          return {
            hours: newHours,
            minutes: newMinutes % 60,
            seconds: newSeconds % 60,
          };
        });
      }, 1000);
      setIntervalId(id);
    } else {
      clearInterval(intervalId);
    }
    return () => clearInterval(intervalId);
  }, [autoTimer]);

  // const debouncedUpdateTimer = debounce((time) => {
  //   dispatch(updateTimerTimesheet({ timerArray: [time] }));
  // }, 5000);

  const formatTimeUnit = (unit: any) => {
    return unit < 10 ? `0${unit}` : unit;
  }

  const stopTimer = () => {
    let tempHours = '';
    timeEntriesList.map((item: any) => {
      if (item.IsTimer) {
        tempHours = getTimeFromDecimal(item.timeEntries.filter((x: any) => x.TimeEntryDate == moment(new Date()).format("YYYY-MM-DD"))[0].Hours, false);;
      }
    });
    dispatch(updateTimerFromNavbarState());
    if ((timerObject[0].hours >= 1 && timerObject[0].minutes >= 0) || (timerObject[0].hours ==0  && timerObject[0].minutes >= 1)) {
      dispatch(stopAccountEmployeeTimeEntryTimerAsync(timeConverIntoSeconds(tempHours)))
        .unwrap()
        .then((result) => {
          if (Number(result.id) > 0) {
            dispatch(updateIsReload(true));
            ShowToast('Success', 'TimeEntry Updated Successfully!!', "success", "toast-top-right");
          }
          else {
            ShowToast('error', 'TimeEntry is not Updated Successfully!', "error", "toast-top-right");
          }
        })
        .catch((rejectedValueOrSerializedError) => {
        })
        .finally(() => {
        });
    } else {
      dispatch(deleteAccountEmployeeTimeEntryTimerAsync()).then((result) => {
        ShowToast('Warning', 'To Save the entry, Total time must be 1 minute or above', "warning", "toast-top-right");
      });
    }
  }

  const switchToClassics = async () => {
    setIsDisabled(isDisabled ? false : true);
    setIsLoading(true);
    if (await callServices(localStorage.getItem('accessToken') ?? "")) {
      setIsLoading(false);
    }
    // const response = await fetchAPI('Services/react.svc/GetUserProfileSetting', 'POST', "", false);
    // const response = await fetchAPI('Services/react.svc/GetLoginFromReact', 'POST', { AccessToken: localStorage.getItem('accessToken') }, false);
    // console.log("This is response", response);
    // if (response.ok) {
    //   const text = await response.text();
    //   const startIndex = text.indexOf('[');
    //   const endIndex = text.lastIndexOf(']') + 1;
    //   if (startIndex !== -1 && endIndex !== -1) {
    //     const jsonText = text.substring(startIndex, endIndex);
    //     const fixedJSONString = jsonText.replace(/\\"/g, '"');
    //     const parsedArray = JSON.parse(fixedJSONString);
    //     if (parsedArray[0].message === "success") {
    //       window.location.href = `${window.origin}/Employee/Default.aspx`;
    //     } else {
    //       ShowToast('Warning', parsedArray[0].message, "warning", "toast-top-right");
    //     }
    //   }
    // } else {
    // }
  }

  const handleClick = () => {
    if (today < cutoffDate) {
      window.location.href = `https://secure.2checkout.com/order/product.php?PRODS=50680211&QTY=1&REF=${localStorage.getItem("accountId")}`;
    } else {
      navigate('/licenseactivation');
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <div className='app-navbar flex-shrink-0'>
        {SelectedCurrentHostedPackage === 'Lite' &&
          <div className={clsx('app-navbar-item', itemClass)} style={{ marginRight: -4 }}>
            {today < cutoffDate && <span className="card-title fw-bold me-2" style={{ marginTop: -2 }}>
              {getValueFromResource('Get a Year of TimeLive — Only Pay for 10 Months!', dispatch, t)}
            </span>}
            <button className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm fs-7" type="button" style={{ height: 36 }}
              onClick={handleClick}>{'Upgrade Now'}
            </button>
          </div>
        }       
        {addAttendance && ((isAttendenceBtn === 'true' || IsTimeInOutAvailable) && isEnableAttandance && pathname !== '/attendance') && (
          <>
            <TimeinTimeout />
          </>
        )}     
        <div className={clsx('app-navbar-item', itemClass)} style={{ marginRight: -4 }}>
          <span className="card-title fw-bold me-2" style={{ marginTop: -2 }}>
            {/* {`Switch to classic`} */}
            {getValueFromResource('Switch to classic', dispatch, t)}
          </span>
          <div className={clsx('position-relative')} >
            <>
              <div style={{ float: 'right', marginTop: 0 }}>
                <div className="form-check form-switch form-check-custom form-check-solid mb-2 me-1">
                  <input
                    className="form-check-input h-20px w-30px"
                    type='checkbox'
                    name='isDisabled'
                    checked={isDisabled}
                    // onChange={(e) => { onSwitch(e) }}
                    onChange={() => { switchToClassics() }}
                    style={{ marginTop: 6 }}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
        <div className={clsx('app-navbar-item', itemClass)}>
          <div className={clsx('position-relative')} >
            <div className={clsx('cursor-pointer symbol')}
              data-kt-menu-trigger="hover"
              data-kt-menu-attach='parent'
              data-kt-menu-placement='bottom-end'
            >


              {lastEntryTimerId > 0 &&
                <>
                  <span className='fs-5 text-gray-700 fw-bold me-2' style={{ cursor: "pointer" }}>{`${formatTimeUnit(time.hours)}:${formatTimeUnit(time.minutes)}:${formatTimeUnit(time.seconds)}`}</span>
                  {/* <span className='fs-5 text-gray-700 fw-bold me-2'>{`${formatTimeUnit(timerObject[0].hours)}:${formatTimeUnit(timerObject[0].minutes)}:${formatTimeUnit(timerObject[0].seconds)}`}</span> */}
                  <div style={{ float: 'right', marginTop: 0 }}>
                    <div className='symbol symbol-circle symbol-10px'>
                      <div className="symbol symbol-25px me-0">
                        <span className="symbol-label bg-light-danger cursor" onClick={() => { stopTimer() }}>
                          <i className="bi bi-stop fs-3 text-danger"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              }
              <TimerInforWedget t={t} />
            </div>
          </div>
        </div>
        {/* <div className={clsx('app-navbar-item', itemClass)}>
          <a
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            className={btnClass}
            href="mailto:feedback@livetecs.com"
            data-tooltip-id="tooltip-Description"
            data-tooltip-content={('Feedback')}
            data-tooltip-place="bottom"
          >
            <KTIcon iconName='message-question' className={btnIconClass} />
          </a>
        </div> */}
        <div className={clsx('app-navbar-item', itemClass)}>
          <a
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end"
            className={btnClass}
            href="https://survey.zohopublic.com/zs/RUBhcw"
            target="_blank"
            data-tooltip-id="tooltip-Description"
            data-tooltip-content="Feedback"
            data-tooltip-place="bottom"
          >
            <KTIcon iconName="message-question" className={btnIconClass} />
          </a>
        </div>
        <div className={clsx('app-navbar-item', itemClass)}>
          <a
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            className={btnClass}
            href={config?.HELP_URL || '#'}
            // href='https://www.livetecs.com/timelivehelp-v13'
            target='_blank'
            data-tooltip-id="tooltip-Description"
            data-tooltip-content={('Help')}
            data-tooltip-place="bottom"
          >
            <KTIcon iconName='question-2' className={btnIconClass} />
          </a>
        </div>
        {/* close Notification */}
        {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='notification-bing' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}
        {showCalendar && (
          <div className={clsx('app-navbar-item', itemClass)}>
            <div className={clsx('position-relative')} >
              <div
                data-kt-menu-trigger="{default: 'click'}"
                data-kt-menu-attach='parent'
                data-kt-menu-placement='bottom-end'
                // className={btnClass}
                className={clsx(btnClass, 'position-relative')}
                data-tooltip-id="tooltip-Description"
                data-tooltip-content={('Notifications')}
                data-tooltip-place="bottom"
              >
                <KTIcon iconName='notification' className={btnIconClass} />
                {(showCalendar && notificationEvents?.length > 0) && (
                  <>
                    <span
                      style={{
                        position: "absolute",
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: "red",
                        top: 10, left: 23
                      }}
                    ></span>
                  </>
                  // <span className="position-absolute translate-middle badge rounded-pill " style={{top: 10, left: 32, backgroundColor: 'red', color: '#fff'}}>
                  //   {notificationEvents?.length}
                  // </span>
                )}
              </div>
              <NotificationWidget t={t} />
            </div>
          </div>
        )}
        {systemSecurityCategoryPageId === 15 && <div className={clsx('app-navbar-item me-2', itemClass)}>
          {/* {masterAccountRoleId == 1 && <div className={clsx('app-navbar-item', itemClass)}> */}
          <a
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            className={btnClass}
            data-tooltip-id="tooltip-Description"
            data-tooltip-content={('Settings')}
            data-tooltip-place="bottom"
          >
            {/* <Link to="/adminPages">
            <KTIcon iconName='setting-2' className={btnIconClass} />
          </Link> */}
            {/* <div className={clsx('app-navbar-item', itemClass)}>
            <button className={btnClass} onClick={handleToggleAdminMenu}>
              <KTIcon iconName='setting-2' className={btnIconClass} />
            </button>
          </div> */}
            <button className={btnClass} onClick={handleToggleAdminMenu}>
              <KTIcon iconName='setting-2' className={btnIconClass} />
            </button>
          </a>
          {/* <HeaderNotificationsMenu /> */}
        </div>
        }
        <div className={clsx('app-navbar-item', itemClass)}>
          <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
          >
            {showEmployeeProfilePicture && profileURL ?
              <img
                // src={profileURL}
                src={`${profileURL}?${new Date().getTime()}`}
                className='tsReportIcon' style={{
                  borderRadius: '50%',
                  width: '30px',
                  height: '30px'
                }} />
              :
              <div className='symbol-label profile-icon-radius' style={{ backgroundColor: profilePictureColor, borderRadius: '0.375rem !important' }}>
                <span className='text-white'>{shortName}</span>
              </div>}
          </div>
          <HeaderUserMenu />
        </div>
        {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )} */}
        <Tooltip id="tooltip-Description"
          style={{ fontSize: 12, fontWeight: 'normal', padding: 8, borderRadius: 6, fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }}
        />
      </div>
    </>
  )
}

export { Navbar }